<template>
  <div id="app">
    <dialogs-wrapper transition-name="fade" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
    @import 'variables.scss';
    @import 'grid.scss';
    #app {
        position: relative;
        width: 100%;
        min-height: calc(100vh);
        @include mobile() {
          overflow: hidden;
        }
    }
    * {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        outline: 0;
    }
    html,
    body {
        color: $mainTextColor;
        font-family: $opensans;
        font-weight: 400;
        height: 100%;
        margin: 0;
        padding: 0;
        width: 100%;
    }
    .spl-info {
      background-image: url(assets/icon-info.svg);
      background-position: center center;
      background-repeat: no-repeat;
      cursor: pointer;
      height: 25px;
      position: absolute;
      right: 5px;
      top: 5px;
      transition: opacity $shortTransition ease-in-out;
      width: 25px;
    }
    .spl-load-img{
      &:after, &:before{
        content: '';
        position: absolute;
        left: 0;right: 0;top: 0;bottom: 0;
        margin: auto;
        width: 45px;
        height: 45px;
        border:10px solid rgba(0,0,0,0);
        border-bottom:10px solid $middleYellow;
        @include border-radius(100%);
        animation: rotate 1s linear infinite;
      }
      &:before{
        width: 60px;
        height: 60px;
        animation-direction: reverse;
      }
    }
    @keyframes rotate {
      from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    .hide-on-mobile {
        @include mobile() {
            display: none;
        }
    }
    .spl-error-message{
      color: $red;
      font-size: 14px;
    }
    .spl-h1 {
        color: $mainTextColor;
        font-size: 45px;
        font-weight: 400;
        margin: 0 0 35px 0;
    }
    .spl-h2 {
        color: $mainTextColor;
        font-size: 28px;
        font-weight: 400;
    }
    .spl-h3 {
        color: $darkCyan;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;

        @include mobile() {
            font-size: 16px;
        }
        &-yellow {
            color: $h3Yellow;
        }
    }
    .spl-h4 {
        color: $radioLabelText;
        font-size: 16px;
        font-weight: 600;
    }
    .spl-text {
        color: $radioLabelText;
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 25px;

        &__formatted{
          display: inline-block;
          float: left;
          @include mobile() {
            white-space: normal;
            float: none;
            display: block;
          }
          white-space: pre;
        }
    }

    .spl-hr {
        background-color: #fff;
        border: none;
        height: 3px;
        margin: 35px #{-$mainPadding};
    }

    .spl-help-tooltip {
        position: relative;
        display: inline-block;
    }

    .spl-function-button {
        color: $middleYellow;
        cursor: pointer;
        display: inline-block;
        font-size: 12px;
        font-weight: 600;
        margin-right: 20px;
        transition: color $shortTransition ease-in-out;

        @include mobile() {
            margin-right: 10px;
        }
        &:hover {
            color: $yellowButtonLabelHover;
        }
    }

.spl-help-tooltip .tooltiptext {
    background-color: $mainTextColor;
    box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.4);
    visibility: hidden;
    width: 280px;
    color: $middleYellow;
    font-size: 14px;
    text-align: center;
    border-radius: 6px;
    padding: 30px;
    position: absolute;
    z-index: 9000;
    bottom: 125%;
    left: 50%;
    margin-left: -130px;
    opacity: 0;
    transition: opacity $longTransition ease-in-out;
}

.spl-help-tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.spl-help-tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}
    .spl-tooltip {
        background-color: $mainTextColor;
        box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.4);
        color: #fff;
        font-size: 14px;
        opacity: 0;
        pointer-events: none;
        padding: 30px;
        position: absolute;
        top: 55px;
        transition: opacity $longTransition ease-in-out;
        width: 280px;
        z-index: 9000;

        &:before {
            border-style: solid;
            border-width: 0 8px 9px 8px;
            border-color: transparent transparent $mainTextColor transparent;
            content: '';
            height: 0;
            position: absolute;
            left: 145px;
            top: -9px;
            width: 0;
        }
        &-show {
            opacity: 1;
            pointer-events: auto;
            transition-duration: $shortTransition;
        }
        &__title {
            color: $h3Yellow;
            font-weight: 600;
            margin-bottom: 5px;
        }
        &__footnote {
            border-top: 1px solid rgba($parcelDetailBlockLabelColor, 0.6);
            color: $parcelListControlsShowColumnsOptions;
            font-size: 14px;
            margin-top: 30px;
            padding-top: 15px;
        }
    }
    .spl-success-toast {
      background-color: $green;
      color: white;
    }
    .spl-error-toast {
      background-color: $red;
      color: white;
    }
    a,
    a:visited,
    a:link,
    a:active {
        color: inherit;
        text-decoration: none;
    }
    .padding-wrapper {
        padding: 0 $mainPadding;

        @include mobile() {
            padding: 0 $mobilePadding;
        }
    }

    .spl-modal-holder {
        background-color: rgba(0, 0, 0, 0.5);
        display: none;
        height: 100vh;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 9000;
        overflow: auto;

        &-show {
            display: block;
        }
        .spl-modal {
            background-color: $parcelTimelineBackgroundColor;
            left: 50%;
            padding: 20px 15px 30px 15px;
            position: absolute;
            top: 25%;
            transform: translate3d(-50%, 0, 0);
            width: 620px;

            @include mobile() {
                left: $mobilePadding;
                transform: translate3d(0, 0, 0);
                top: $mobilePadding;
                width: calc(100% - #{$mobilePadding*2});
            }
            &__label {
                font-size: 18px;
                font-weight: 600;
                margin-bottom: 20px;
            }
            &__close {
                background-image: url(assets/icon-close.svg);
                background-position: center center;
                background-repeat: no-repeat;
                cursor: pointer;
                height: 25px;
                position: absolute;
                right: 10px;
                top: 20px;
                transition: opacity $shortTransition ease-in-out;
                width: 25px;

                &:hover {
                    opacity: 0.5;
                }
            }
            .spl-label {
                color: $parcelDetailBlockLabelColor;
            }
            .spl-button {
                margin-bottom: 0;
            }
        }
    }

    @include mobile () {
      .spl-modal-holder {
        .spl-modal {
          transform: translate3d(0, 0, 0);
          top: 0;
          left: 0;
          padding: 20px 7px 30px 7px;
          width: calc(100%);
          min-height: calc(100%);
          .spl-button,
          .spl-label {
            margin-top: 15px;
          }
        }
      }
    }

    .el-date-editor {
      width: 100%;
    }

.order-arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.order-arrow.asc {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #e79c1e;
}

.order-arrow.desc {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #e79c1e;
}
.order-column-arrow {
  display: inline-block;
  align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}
.order-column-arrow.left {
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid #e79c1e;
}

.order-column-arrow.right {
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #e79c1e;
}
    .spl-edit-template {
        background-color: $tableRowBackgroundColorSelected;
        min-height: 100vh;
        padding: 50px $mainPadding;

        @include mobile() {
            padding: 0;
        }
        &__step-header-holder {
            background-color: $yellowButtonLabelHover;
            height: 60px;
            padding: 17px $mobilePadding;
            position: absolute;
            top: 70px;
            width: 100%;
            z-index: 3000;

        }
        &__step-header {
            width: 1200px;

            &__step {
                color: rgba(#fff, 0.42);
                display: inline-block;
                font-size: 18px;
                font-weight: 600;
                margin-right: 40px;
                position: relative;
                transition: color $shortTransition ease-in-out;
                cursor: pointer;
                &-valid:after {
                    background-image: url(assets/icon-checkmark-yellow.svg);
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: 14px 20px;
                    content: '';
                    height: 12px;
                    margin-left: 5px;
                    right: -22px;
                    position: absolute;
                    top: 8px;
                    width: 20px;
                }
                &-active {
                    color: #fff;
                }
            }
        }
        &__step {
            background-color: $tableRowBackgroundColorSelected;
            margin: 0 #{-$mainPadding};
            margin-bottom: 40px;
            padding: 35px $mainPadding;

            &:first-child {
                border-top: none;
                padding-top: 0;
            }
        }
        &__step-footer {
            background-color: $parcelBookStepFooterBackgroudColor;
            bottom: 0;
            color: rgba(#fff, 0.4);
            font-size: 16px;
            font-weight: 600;
            height: 70px;
            line-height: 70px;
            position: fixed;
            text-align: center;
            transition: all $shortTransition ease-in-out;
            width: 100%;
            z-index: 3000;

            &-active {
                background-color: $mainInputColor;
                color: #fff;
                cursor: pointer;
            }
        }
        &__section {
            border-top: 3px solid #fff;

            &:first-child {
                border-top: none;
            }
        }
        @include mobile() {
            @for $i from 0 through $columnCount {
                .col#{$i} {
                    width: 100%;
                }
            }
        }
    }
    .error {
      font-size: 12px;
      color: $red;
      display: block;
      margin-top: 5px;
      margin-left: 1px;
    }
</style>
